import React from 'react';
import { Users, Smartphone, MapPin, ShieldCheck, Headphones } from 'lucide-react';
import { TRUST_STATS } from '../mock/mock';

const iconMap = { Users, Smartphone, MapPin, ShieldCheck, Headphones };

const TrustBar = () => {
  return (
    <section className="relative -mt-4 z-10">
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10">
        <div className="glass-card rounded-3xl p-5 lg:p-6">
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 lg:gap-2">
            {TRUST_STATS.map((s, i) => {
              const Icon = iconMap[s.icon];
              return (
                <div key={s.label} className={`flex items-center gap-3 px-3 py-2 ${i < TRUST_STATS.length - 1 ? 'md:border-r md:border-purple-100' : ''}`}>
                  <div className="w-11 h-11 rounded-2xl gradient-soft border border-purple-100 flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 text-[#5F259F]" />
                  </div>
                  <div>
                    <div className="text-2xl font-black gradient-text leading-none">{s.value}</div>
                    <div className="text-[11px] font-semibold text-slate-500 mt-1">{s.label}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBar;
